import { GeneralInvokeOption } from 'src/types';
import {
  getRealRoute,
  encodeUrlQuery,
  checkUrl,
  logErrorAndRunFail
} from '../utils';
import MacleJSBridge from 'src/bridges';
import { APINames, CURRENT_ROUTE, getGlobal } from 'src/shared';

export interface SwitchTabOption extends Partial<GeneralInvokeOption> {
  url: string;
}

/**
 * ```js
 *   ma.miniProgram.switchTab({
 *     url: '/example',
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function switchTab(option: SwitchTabOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.MiniProgram.SWITCH_TAB,
      option,
      'parameter error:parameter.url should be String instead of Undefined.'
    );
  }
  const switchToOption = option;
  switchToOption.url = getRealRoute(
    getGlobal(CURRENT_ROUTE) as string,
    switchToOption.url
  );
  switchToOption.url = encodeUrlQuery(switchToOption.url);

  if (checkUrl(APINames.MiniProgram.SWITCH_TAB, switchToOption)) {
    MacleJSBridge.beforeInvoke(APINames.MiniProgram.SWITCH_TAB, switchToOption);
  }
}
